





































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {DebtEmployee} from "@/interfaces/entity";
import {ReceiptEmployeeStore} from "@/modules/receiptsexpenses/receiptemployee/store";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Ngày phát hành",
        dataIndex: "billLading.ladingDate",
        key: "ladingDate",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: 'ladingDate'}
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: "ladingCode"}
    },
    {
        title: "Thu hộ COD",
        dataIndex: "billLading.codMoney",
        key: "COD",
        scopedSlots: {customRender: 'codMoney'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng cước",
        dataIndex: "billLading.totalFee",
        key: "totalMoney",
        scopedSlots: {customRender: 'totalFee'},
        width: 120,
        ellipsis: true
    },
    {
        title: "HT Thanh toán",
        dataIndex: "billLading.payment",
        key: "payment",
        scopedSlots: {customRender: 'payment'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng thu",
        dataIndex: "money",
        key: "money",
        scopedSlots: {customRender: 'money'},
        width: 120,
        ellipsis: true
    },
    {
        title: "Trạng thái bưu gửi",
        dataIndex: "billLading.status",
        key: "statusLading",
        scopedSlots: {customRender: 'statusLading'},
        width: 180,
        ellipsis: true
    },
    {
        title: "Nhân viên",
        dataIndex: "employee.fullname",
        key: "employee",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: "employeeName"}
    }
];
@Component({
    name: "ReceiptEmployeeTable",
    components: {TooltipLabel, LadingStatusLabel, LadingPaymentTypeLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly debtEmployees!: Array<DebtEmployee>;
    columns = columns;

    get pagination() {
        return {
            current: ReceiptEmployeeStore.meta.page,
            pageSize: ReceiptEmployeeStore.meta.limit,
            total: ReceiptEmployeeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ReceiptEmployeeStore.updateParamsDebtEmployee({
            ...ReceiptEmployeeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ReceiptEmployeeStore.listDebtEmployee(ReceiptEmployeeStore.params);
    }
}
